/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
import * as tslib_1 from "tslib";
import * as classNames from "classnames";
import * as PureRender from "pure-render-decorator";
import * as React from "react";
import * as Classes from "../../common/classes";
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
var Label = (function (_super) {
    tslib_1.__extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, disabled = _a.disabled, helperText = _a.helperText, text = _a.text, htmlProps = tslib_1.__rest(_a, ["children", "className", "disabled", "helperText", "text"]);
        var rootClasses = classNames(Classes.LABEL, (_b = {},
            _b[Classes.DISABLED] = disabled,
            _b), className);
        return (React.createElement("div", tslib_1.__assign({}, htmlProps, { className: rootClasses }),
            text,
            React.createElement("span", { className: classNames(Classes.TEXT_MUTED) }, helperText),
            children));
        var _b;
    };
    Label.displayName = "Blueprint.Label";
    Label = tslib_1.__decorate([
        PureRender
    ], Label);
    return Label;
}(React.Component));
export { Label };
export var LabelFactory = React.createFactory(Label);



//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/dist/esm/components/forms/label.js
// module id = 897
// module chunks = 0